// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2dBAl","header":"PatientQuestionnaire_header__1e4y5","info":"PatientQuestionnaire_info__zer08"};